import { render } from "./4.MaterialSchedule.vue?vue&type=template&id=68dd95a9&scoped=true"
import script from "./4.MaterialSchedule.vue?vue&type=script&lang=js"
export * from "./4.MaterialSchedule.vue?vue&type=script&lang=js"

import "./4.MaterialSchedule.vue?vue&type=style&index=0&id=68dd95a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dd95a9"]])

export default __exports__